import React from 'react';

import brandBanner from "./images/logo.png"

import './styles/dashboard.css';
import NetworkChart from './networkchart';

export default class Social extends React.Component {
    render() {
        let nodes = [];
        for (let i = 0; i < 100; i++) {
            let depth = parseInt(3 * Math.random());
            nodes.push({
                "id": i.toString(),
                "radius": depth == 0 ? 8 : (depth == 1 ? 6 : 4),
                "depth": depth,
                "color": depth == 0 ? "red" : (depth == 1 ? "green" : "blue")
            });
        }
        nodes[0].color = "black";
        let links = []
        for (let i = 0; i < 100; i++) {
            links.push({
                "source": i.toString(),
                "target": parseInt(100 * Math.random()).toString(),
                "distance": parseInt(50 * Math.random())
            })
        }
        let wlbData = {
            nodes: nodes,
            links: links
        };

        return (
            <div className="row-fluid">
                <br></br>
                <img src={brandBanner} className="img-fluid" style={{ height: "64px" }}></img>
                <br></br><br></br>
                <p>
                    On SkillEd, you can make new friends and learn new skills along the way. You can also mentor others in things you are good at. With SkillEd, we bring the personal touch to skill sharing.
                </p>
                <h3>Social Impact</h3>
                <div className="row">
                    <div className="col">
                        <div style={{ height: "380px" }}>
                            <NetworkChart
                                data={wlbData}
                            />
                        </div>
                    </div>
                    <div className="col"></div>
                </div>

                <br></br><br></br><br></br><br></br>
            </div>
        );
    }
}